import {
	UpdateFieldObjectNameEnum,
	UpdateHistoryRefTableNameEnum,
} from '@/constant';
import { useFormikUpdateCustom } from '@/hooks';
import {
	Fm1_01DefaultInfoUnitActions,
	TDataUpdateFieldsRequest,
} from '@/stores';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { mapPropsToValues } from './config';
import { IProps, TValues } from './type';

export const useLogic = (props: IProps) => {
	const { id, values } = props;
	const initialValues = useMemo(() => {
		return mapPropsToValues(values);
	}, [values]);
	const dispatch = useDispatch();

	const formik = useFormikUpdateCustom<TValues>({
		objectName: UpdateFieldObjectNameEnum.UNIT,
		id: id,
		updateHistoryRefTableName: UpdateHistoryRefTableNameEnum.UNIT,
		formikConfig: {
			initialValues,
		},
		// removeKeys: ['providerTable'],
		onSubmitSuccess: (data: TDataUpdateFieldsRequest['data']) => {
			dispatch(
				Fm1_01DefaultInfoUnitActions.updateDefaultInfoUnitSuccess({
					data,
				})
			);
		},
	});
	return {
		formik,
	};
};
